import React from 'react';
import { IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { SYS_COLOR_CANVAS_DEFAULT_LIGHT } from '@oneaudi/unified-web-common';
import type { LayerTypes } from './globals';

const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${SYS_COLOR_CANVAS_DEFAULT_LIGHT};
  z-index: 100;
`;

type Icon = {
  icon: string;
};

interface IClose {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose: (e: any) => void;
  type?: LayerTypes;
  icon?: Icon;
}

const DefaultCloseButton: React.FC<IClose> = (props) => {
  const { onClose } = props;
  return (
    <IconButton
      href="#"
      aria-label="close button"
      data-testid="one-layer-close"
      onClick={onClose}
      title="closebutton"
      rel="noopener"
      size="md"
      variant="tertiary"
      icon="cancel"
    />
  );
};

const Close: React.FC<IClose> = (props) => {
  return (
    <CloseButtonWrapper>
      <DefaultCloseButton {...props} />
    </CloseButtonWrapper>
  );
};

export default Close;
